import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import shape from "../../../assets/img/antex-ui-shape.png";
import { OnProgress } from "../../../IconTheme";
const AntexUI = () => {
	const settings = {
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 3,
		arrows: false,
		margin: 30,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	return (
		<section className="antex-ui-section">
			<div className="container">
				<Slider {...settings}>
					{["", "", "", ""].map((item, i) => (
						<div className="antex-ui-card" key={i}>
							<div className="inner">
								<h3 className="title text-uppercase">
									<Link to="/">AntexPad - v2</Link>
								</h3>
								<div className="subtitle">Project - UI Design</div>
								<span className="status">
									<span className="icon">
										<OnProgress />
									</span>{" "}
									<span className="txt">ON PROGRESS</span>
								</span>
							</div>
							<img src={shape} className="antex-ui-shape" alt="" />
						</div>
					))}
				</Slider>
			</div>
		</section>
	);
};

export default AntexUI;
